var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclamationMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1791_111326)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 6.85889V12.4303M16.7878 22.6425C16.4663 22.9639 16.0303 23.1446 15.5756 23.1446H8.42433C7.96969 23.1446 7.53364 22.9639 7.21216 22.6425L1.35922 16.7896C1.03773 16.4681 0.857117 16.032 0.857117 15.5774V8.4261C0.857117 7.97146 1.03773 7.53541 1.35922 7.21393L7.21216 1.36099C7.53364 1.0395 7.96969 0.858887 8.42433 0.858887H15.5756C16.0303 0.858887 16.4663 1.0395 16.7878 1.36099L22.6407 7.21393C22.9621 7.53541 23.1428 7.97146 23.1428 8.4261V15.5774C23.1428 16.032 22.9621 16.4681 22.6407 16.7896L16.7878 22.6425Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_1791_111326",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0006 16.9995C11.448 16.9995 11.0001 16.5518 11.0001 15.9995C11.0001 15.4471 11.448 14.9995 12.0006 14.9995"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9992 16.9995C12.5521 16.9995 13.0001 16.5519 13.0001 15.9995C13.0001 15.4472 12.5521 14.9996 11.9992 14.9996"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.0006 18.4995C12.829 18.4995 13.5006 17.8279 13.5006 16.9995C13.5006 16.171 12.829 15.4995 12.0006 15.4995V18.4995ZM12.0006 16.4995C12.829 16.4995 13.5006 15.8279 13.5006 14.9995C13.5006 14.1711 12.829 13.4995 12.0006 13.4995V16.4995ZM11.9992 15.4995C11.1707 15.4995 10.4992 16.1711 10.4992 16.9995C10.4992 17.8279 11.1707 18.4995 11.9992 18.4995V15.4995ZM11.9992 13.4996C11.1707 13.4996 10.4992 14.1711 10.4992 14.9996C10.4992 15.828 11.1707 16.4996 11.9992 16.4996V13.4996ZM12.0006 15.4995C12.2756 15.4995 12.5001 15.7226 12.5001 15.9995H9.50006C9.50006 17.3811 10.6204 18.4995 12.0006 18.4995V15.4995ZM12.5001 15.9995C12.5001 16.2764 12.2756 16.4995 12.0006 16.4995V13.4995C10.6204 13.4995 9.50006 14.6179 9.50006 15.9995H12.5001ZM11.9992 18.4995C13.3794 18.4995 14.5001 17.3815 14.5001 15.9995H11.5001C11.5001 15.7223 11.7249 15.4995 11.9992 15.4995V18.4995ZM14.5001 15.9995C14.5001 14.6176 13.3794 13.4996 11.9992 13.4996V16.4996C11.7249 16.4996 11.5001 16.2768 11.5001 15.9995H14.5001Z",
    fill: "black",
    mask: "url(#path-2-inside-1_1791_111326)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1791_111326"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationMark);
export default __webpack_public_path__ + "static/media/exclamationMark.65c3810303254df5ec0b04a7221fc618.svg";
export { ForwardRef as ReactComponent };